import template from './register_dialog.html';
import tr from '../../lib/default-translator.js';

class RegistrationViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.records = ko.observableArray();
		this.employee = ko.observable({
			employee_id: null,
			firstname: ko.observable(),
			surname: ko.observable(),
			id_number: ko.observable(),
			email: ko.observable(),
			gender: ko.observable(),
			guid: null,
			grape_user_id: null
		});
	};

	close()
	{
		this.dialog.close();
	}

	async save_employee(data)
	{
		let info = ko.toJS(data.employee);
		info.fields = [];
	
		//validation on email before attemtping to save employee: 
		let valid = true;
		let msg = ''
	
		// Regular expression for basic email validation
		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
		if (!info.email)
		{
			valid = false;
			msg = tr('Please enter an email address before requesting access');
		}
		else if (!emailPattern.test(info.email))
		{
			valid = false;
			msg = tr('Please enter a valid email address');
		}
	
		if (valid)
		{
			let res = await Grape.fetches.postJSON('/employee/register', info);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully registered, Please wait for approval to gain access.'), title: tr('Success')});
			
				this.employee({
					employee_id: null,
					firstname: ko.observable(''),
					surname: ko.observable(''),
					id_number: ko.observable(''),
					email: ko.observable(''),
					// gender: ko.observable(''),
					guid: null,
					grape_user_id: null
				});
				this.dialog.close(true)
			}
			else if (res.status == 'ERROR')
				Grape.alerts.alert({ type: 'error', message: res.message, title: tr('Error') });
		}
		else
			Grape.alerts.alert({type: 'error', message: msg, title: tr('Error')});
	};
};

class RegistrationPage
{
	constructor(bindings)
	{
		this.viewModel = new RegistrationViewModel(this);
		this.bindings = bindings;
		this.gender_lookup = ko.observableArray();
	}

	init()
	{
		document.title = tr('Request Access');
	};
};

export default {
	name: 'PSRegistration',
	dialog_class: RegistrationPage,
	template: template,
	template_filename: 'translation/dialogs/register_dialog',
	provider: 'ps'
};
